import { apiClient, unwrap } from '@services/api';
import type { AuthTokens, User } from '@/types';

export interface SsoExchangeResponse {
  user: User;
  tokens: AuthTokens;
}

export const ssoService = {
  async exchangeCode(code: string): Promise<SsoExchangeResponse> {
    const res = await apiClient.post<SsoExchangeResponse>('/auth/sso/exchange', { code });
    return unwrap(res);
  },
};
